// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listing-tabs-container {
  margin-top: 0px;
  display: flex;
  justify-content: center;
}
.listing-tabs-container .tabs .tab-indicator {
  height: 5px;
  margin-top: -5px;
}
.listing-tabs-container .tabs .tab-header {
  margin-top: 5px;
}
.listing-tabs-container .tabs .tab-header .tab-item {
  font-size: 14px;
  font-weight: 700;
  font-family: "Proxima Nova", sans-serif;
  color: var(--secondary-color-2);
  width: 150px;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.listing-tabs-container .tabs .tab-header .tab-item.active {
  color: var(--secondary-color-1);
}
.listing-tabs-container .tabs {
  display: flex;
  flex-direction: column;
  width: calc(150px * var(--items));
}
.listing-tabs-container .tabs .tab-header {
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  width: 100%;
}
.listing-tabs-container .tabs .tab-header > div {
  text-align: center;
  color: var(--secondary-color-2);
  cursor: pointer;
  outline: none;
  width: 150px;
}
.listing-tabs-container .tabs .tab-header > div > i {
  display: block;
  margin-bottom: 5px;
}
.listing-tabs-container .tabs .tab-header > div.active {
  color: var(--secondary-color-1);
}
.listing-tabs-container .tabs .tab-indicator {
  position: relative;
  height: 10px;
  background: var(--primary-color-1);
  left: 0px;
  border-radius: 10px;
  transition: all 500ms ease-in-out;
  max-width: 150px;
}
.listing-tabs-container .tabs .tab-body {
  position: relative;
  height: calc(100% - 60px);
  padding: 10px 0px;
}
.listing-tabs-container .tabs .tab-body > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 10px;
  opacity: 0;
  display: none;
  transition: all 1s ease-in-out 0ms;
  animation: fadeinout 1s linear forwards;
}
.listing-tabs-container .tabs .tab-body > div.active {
  animation: fadein 0.8s;
  padding-top: 24px;
  opacity: 1;
  display: flex;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .listing-tabs-container {
    margin-top: 0px;
  }
  .listing-tabs-container .tabs {
    margin-left: 0;
  }
  .listing-tabs-container .tabs .tab-header {
    flex-wrap: wrap;
    justify-content: center;
  }
  .listing-tabs-container .tabs .tab-header .tab-item {
    width: -moz-fit-content;
    width: fit-content;
    padding: 5px 10px;
    margin-bottom: 10px;
    position: relative;
  }
  .listing-tabs-container .tabs .tab-header .tab-item::before {
    content: "";
    width: 100%;
    height: 3px;
    border-radius: 10px;
    background-color: transparent;
    position: absolute;
    bottom: 0;
    left: 0;
    transition: 0.5s ease-in-out;
  }
  .listing-tabs-container .tabs .tab-header .tab-item.active::before {
    background-color: var(--primary-color-1);
  }
  .listing-tabs-container .tabs .tab-indicator {
    display: none;
  }
  .listing-tabs-container .tabs .tab-body > div.active {
    padding-top: 0px;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .listing-tabs-container {
    margin-top: 0px;
  }
  .listing-tabs-container .tabs {
    margin-left: 0;
  }
  .listing-tabs-container .tabs .tab-header {
    flex-wrap: wrap;
    justify-content: center;
  }
  .listing-tabs-container .tabs .tab-header .tab-item {
    width: -moz-fit-content;
    width: fit-content;
    padding: 5px 10px;
    margin-bottom: 10px;
    position: relative;
  }
  .listing-tabs-container .tabs .tab-header .tab-item::before {
    content: "";
    width: 100%;
    height: 3px;
    border-radius: 10px;
    background-color: transparent;
    position: absolute;
    bottom: 0;
    left: 0;
    transition: 0.5s ease-in-out;
  }
  .listing-tabs-container .tabs .tab-header .tab-item.active::before {
    background-color: var(--primary-color-1);
  }
  .listing-tabs-container .tabs .tab-indicator {
    display: none;
  }
  .listing-tabs-container .tabs .tab-body > div.active {
    padding-top: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/Listing/modules/ListingDetail/modules/Tabs/tabs.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,eAAA;EACA,aAAA;EACA,uBAAA;AADJ;AAEI;EACI,WAAA;EACA,gBAAA;AAAR;AAEI;EACI,eAAA;AAAR;AACQ;EACI,eAAA;EACA,gBAAA;EACA,uCAAA;EACA,+BAAA;EACA,YAAA;EACA,eAAA;EACA,4BAAA;AACZ;AAAY;EACI,+BAAA;AAEhB;AAEI;EACI,aAAA;EACA,sBAAA;EACA,iCAAA;AAAR;AACQ;EACI,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AACZ;AAAY;EACI,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;AAEhB;AADgB;EACI,cAAA;EACA,kBAAA;AAGpB;AADgB;EACI,+BAAA;AAGpB;AACQ;EACI,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,SAAA;EACA,mBAAA;EACA,iCAAA;EAEA,gBAAA;AAAZ;AAEQ;EACI,kBAAA;EACA,yBAAA;EACA,iBAAA;AAAZ;AACY;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,kCAAA;EAEA,uCAAA;AAChB;AAAgB;EACI,sBAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;AAEpB;AAGI;EACI;IACI,UAAA;EADV;EAIM;IACI,UAAA;EAFV;AACF;;AC9EY;EDoFR;IACI,eAAA;EAFN;EAGM;IACI,cAAA;EADV;EAEU;IACI,eAAA;IACA,uBAAA;EAAd;EACc;IACI,uBAAA;IAAA,kBAAA;IACA,iBAAA;IACA,mBAAA;IACA,kBAAA;EAClB;EAAkB;IACI,WAAA;IACA,WAAA;IACA,WAAA;IACA,mBAAA;IACA,6BAAA;IACA,kBAAA;IACA,SAAA;IACA,OAAA;IACA,4BAAA;EAEtB;EACsB;IACI,wCAAA;EAC1B;EAKU;IACI,aAAA;EAHd;EAOkB;IACI,gBAAA;EALtB;AACF;AC5HY;ED2FR;IACI,eAAA;EAoCN;EAnCM;IACI,cAAA;EAqCV;EApCU;IACI,eAAA;IACA,uBAAA;EAsCd;EArCc;IACI,uBAAA;IAAA,kBAAA;IACA,iBAAA;IACA,mBAAA;IACA,kBAAA;EAuClB;EAtCkB;IACI,WAAA;IACA,WAAA;IACA,WAAA;IACA,mBAAA;IACA,6BAAA;IACA,kBAAA;IACA,SAAA;IACA,OAAA;IACA,4BAAA;EAwCtB;EArCsB;IACI,wCAAA;EAuC1B;EAjCU;IACI,aAAA;EAmCd;EA/BkB;IACI,gBAAA;EAiCtB;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n.listing-tabs-container {\r\n    margin-top: 0px;\r\n    display: flex;\r\n    justify-content: center;\r\n    .tabs .tab-indicator {\r\n        height: 5px;\r\n        margin-top: -5px;\r\n    }\r\n    .tabs .tab-header {\r\n        margin-top: 5px;\r\n        .tab-item {\r\n            font-size: 14px;\r\n            font-weight: 700;\r\n            font-family: 'Proxima Nova', sans-serif;                                             \r\n            color: var(--secondary-color-2);\r\n            width: 150px;\r\n            cursor: pointer;\r\n            transition: .2s ease-in-out;\r\n            &.active {\r\n                color: var(--secondary-color-1);\r\n            }\r\n        }\r\n    }\r\n    .tabs {\r\n        display: flex;\r\n        flex-direction: column;\r\n        width: calc(150px * var(--items));\r\n        .tab-header {\r\n            padding-bottom: 10px;\r\n            display:flex;\r\n            align-items:center;\r\n            width: 100%;\r\n            > div {\r\n                text-align: center;\r\n                color: var(--secondary-color-2);\r\n                cursor: pointer;\r\n                outline: none;\r\n                width: 150px;\r\n                > i {\r\n                    display:block;\r\n                    margin-bottom:5px;\r\n                }\r\n                &.active {\r\n                    color: var(--secondary-color-1);\r\n                }\r\n            }\r\n        }\r\n        .tab-indicator {\r\n            position:relative;\r\n            height: 10px;\r\n            background: var(--primary-color-1);\r\n            left:0px;\r\n            border-radius: 10px;\r\n            transition:all 500ms ease-in-out;\r\n            // width: calc(100% / var(--items));\r\n            max-width: 150px;\r\n        }\r\n        .tab-body {\r\n            position:relative;\r\n            height:calc(100% - 60px);\r\n            padding:10px 0px;\r\n            > div {\r\n                display: flex;\r\n                flex-direction: column;\r\n                align-items: center;\r\n                width: 100%;\r\n                min-height: 10px;\r\n                opacity:0;\r\n                display: none;\r\n                transition: all 1s ease-in-out 0ms;\r\n                -webkit-animation: fadeinout 1s linear forwards;\r\n                animation: fadeinout 1s linear forwards;\r\n                &.active {\r\n                    animation: fadein .8s;\r\n                    padding-top: 24px;\r\n                    opacity:1;\r\n                    display: flex;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    @keyframes fadein {\r\n        from {\r\n            opacity: 0;\r\n        }\r\n    \r\n        to {\r\n            opacity: 1;\r\n        }\r\n    }\r\n}\r\n@include media(tablet, mobile) {\r\n    .listing-tabs-container {\r\n        margin-top: 0px;\r\n        .tabs {\r\n            margin-left: 0;\r\n            .tab-header {\r\n                flex-wrap: wrap;\r\n                justify-content: center;\r\n                .tab-item {\r\n                    width: fit-content;\r\n                    padding: 5px 10px;\r\n                    margin-bottom: 10px;\r\n                    position: relative;\r\n                    &::before {\r\n                        content: '';\r\n                        width: 100%;\r\n                        height: 3px;\r\n                        border-radius: 10px;\r\n                        background-color: transparent;\r\n                        position: absolute;\r\n                        bottom: 0;\r\n                        left: 0;\r\n                        transition: .5s ease-in-out;\r\n                    }\r\n                    &.active {\r\n                        &::before {\r\n                            background-color: var(--primary-color-1);\r\n\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            .tab-indicator {\r\n                display: none;\r\n            }\r\n            .tab-body {\r\n                > div {\r\n                    &.active {\r\n                        padding-top: 0px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
